// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Vy9s","clinicsSelect":"styles_clinicsSelect__3CQtj"};